export default __webpack_public_path__ + "content/media/28.a7068166.jpg";